export default __webpack_public_path__ + "static/media/DaviMarcos_06.07ccc983.jpg";